var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechHandPill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "neutral_14_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.6,293.5c-6-7.9-19.7-17.8-48.1-5.4c-0.6-2.6-1.6-4.9-3-7c-3.3-5.2-8.6-8.5-15.7-9.9 c-9.1-1.8-20.7,0.1-31.8,5c-1.7-4.5-4.6-7.3-6.8-9c-13.2-9.7-37.4-3.3-49.7,4c-11.7,7-47.2,29.5-58.5,36.7c-11.2-3-21-6.3-25.5-9 c-2.6-1.5-5.3-4.5-8.4-8c-10.5-11.6-26.4-29.1-69.2-29.1c-22.3,0-32.8,4.4-43.9,9l-5.1,2.1c-23.2,9.2-63.2,28.5-64.9,29.3 c-4.4,2.1-6.2,7.4-4.1,11.8c2.1,4.4,7.4,6.3,11.8,4.2c0.4-0.2,41.1-19.8,63.7-28.8c1.8-0.7,3.6-1.5,5.3-2.2 c10.3-4.3,18.4-7.6,37.1-7.6c35.1,0,46.3,12.4,56.2,23.3c3.9,4.3,7.6,8.4,12.4,11.3c5.9,3.6,18.2,7.8,31.9,11.4 c1.2,0.6,2.4,0.9,3.7,0.9c14.8,3.6,30.7,6.3,41.8,6.3c9.9,0,26.5,1.7,26.5,13.3c0,3.3,0,13.3-26.5,13.3h-51.2 c-22.2,0-52-8.4-52.3-8.5c-4.7-1.3-9.6,1.4-10.9,6.1c-1.3,4.7,1.4,9.6,6.1,11c1.3,0.4,32.4,9.2,57.1,9.2h51.2 c20.4,0,31.6-5.5,37.6-12.4c0.4-0.2,0.9-0.4,1.3-0.7l79.4-53.7c18.8-11.2,32.8-13.4,38.4-6.1c2.2,2.9,2.1,5.1,1.9,6.6 c-0.5,3.1-3.2,9.7-15.9,18.7c-11.4,8.1-125.4,84.3-140.9,93.3c-2.5,1.5-5,3-7.5,4.6c-15.6,9.9-29.2,18.4-58.6,4 c-9.2-4.5-39.1-20.1-60.8-31.4l-18.8-9.8c-20.7-10.7-31.4-8.1-46.4,1.5l-23.8,15.6c-4.1,2.7-5.2,8.2-2.6,12.3 c2.7,4.1,8.1,5.2,12.2,2.6l23.7-15.6c10.9-7,14.8-7.9,28.7-0.7l18.7,9.8c21.9,11.4,51.8,27,61.3,31.7c14,6.9,25.7,9.4,35.7,9.4 c17.3,0,29.5-7.7,40-14.4c2.3-1.5,4.6-2.9,6.9-4.3c16.4-9.5,130.4-85.7,142.3-94.2c13.8-9.8,21.5-20.1,23.1-30.5 C470,306.4,468.2,299.5,463.6,293.5z M305.5,316c-3.8-0.6-8-0.9-12.7-0.9c-4.9,0-11.3-0.7-18.1-1.8c15-9.5,34.9-22,42.9-26.8 c9.7-5.8,25.5-8.4,30.2-4.9c1.1,0.8,1.3,2.5,1.1,4.3L305.5,316z M398.5,297.5l-62.3,42.1c-1.2-4.9-4-11.1-10.6-16l36.4-25.2 c0.4-0.2,0.7-0.5,1-0.8c11.8-8,24-10.3,30.5-9c2.2,0.4,3.7,1.2,4.4,2.2C398.2,291.5,399,293.3,398.5,297.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "color_10_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.4,112.6l12.5-12.5l81.5,81.5l-12.5,12.5L237.4,112.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.6,257.9c-17.6,0-34.2-6.9-46.6-19.3l-2.1-2.1c-25.7-25.7-25.7-67.5,0-93.2l85.7-85.6 c12.4-12.4,29-19.3,46.6-19.3c17.6,0,34.2,6.9,46.6,19.3l2.1,2.1c25.7,25.7,25.7,67.5,0,93.2l-85.7,85.6 C275.7,251.1,259.2,257.9,241.6,257.9z M325.1,57.9c-12.4,0-24,4.8-32.8,13.6l-85.7,85.6c-18.1,18.1-18.1,47.5,0,65.6l2.1,2.1 c8.8,8.8,20.4,13.6,32.8,13.6c12.4,0,24-4.8,32.8-13.6l85.7-85.6c18.1-18.1,18.1-47.5,0-65.6l-2.1-2.1 C349.2,62.7,337.5,57.9,325.1,57.9z"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })));
}

export default SvgAlvotechHandPill;